export default "__VITE_ASSET__qsXqMtRZ__"